
class FiltroBuscarService {

    constructor($http, filtroBuscarFactory) {

        this.$http = $http;
        this.filtroBuscarFactory = filtroBuscarFactory;
    }

    obtenerFiltro() {

        return this.filtroBuscarFactory.obtenerFiltro();
     }

     buscar (params, success, error) {
         this.filtroBuscarFactory.guardarFiltro(params);

         this.$http.get('api/documentos-buscar/', {
             params: params
         }).
           then(
                  (response) =>{
                     success(response);
                 },
                  (response)=> {
                     error(response);
                 }
             );
     }
     
    // aqui tienes un path distinto ... debes fijarte en esas cosas 
     sugerir (params, success, error) {

         return this.$http.get('buscador/api/documentos-buscar/sugerencia', {
             params: params
         })
           .then(
                    (response) => {
                     return response.data.datos.map( (item)=> {

                         return item;
                     });
                 },
                  (response) => {
                     error(response);
                 }
             );
     }

     recargar(params, success, error) {
         this.$http.get('buscador/api/documentos-buscar/recarga', {
             params: params
         })
             .then(
                  (response) =>{
                      success(response);
                  },
                  (response) =>{
                      error(response);
                  }
             );
     }

     exportar(params, success, error) {

         this.$http.get('api/documentos-buscar/exportacion', {
             params: params
         })
            .then(
                  (response) =>{
                     success(response);
                 },
                  (response) =>{
                     error(response);
                 }
             );
     };
     
     recargar(params, success, error) {
         this.$http.get('api/documentos-buscar/recarga', {
             params: params
         })
             .then(
                  (response) =>{
                     success(response);
                 },
                  (response) =>{
                     error(response);
                 }
             );
     }
     
     crear(params, success, error) {
		 this.$http.post('api/documentos-buscar/creacion', params)
             .then(
                  (response) =>{
                     success(response);
                 },
                  (response) =>{
                     error(response);
                 }
             );
     };

}

FiltroBuscarService.$inject = ['$http', 'filtroBuscarFactory'];


export default FiltroBuscarService;


// WEBPACK FOOTER //
// ./src/busqueda/servicios/buscador.service.js